var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-film"},[_c('error',{attrs:{"errors":_vm.membershipError}}),_c('membership-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }